module.exports = __webpack_public_path__ + "img/1078207549.0db6e45a.jpg";